module.exports = __webpack_public_path__ + "static/media/whatsapp.8b357b47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whatsapp.png
// module id = 336
// module chunks = 0 1 2